<template>
  <Field :name="name" v-slot="{ field }" v-model="maskedValue">
    <!--
      `id`, `aria-describedby`, `aria-label` e `required` precisam de props próprias.

      Este componente tem um COMPONENTE na raiz do template (<Field> do vee-validate), e
      não um elemento: os atributos que a tela passa por fora (fallthrough) iriam para o
      <Field>, não para o <input> de dentro. O resultado era que não havia como um
      `<label for>` alcançar o campo mascarado nem como dar-lhe um nome acessível — o
      leitor de tela anunciava apenas "edição, em branco".
    -->
    <input :id="campoId" type="text" class='form-control' ref="input" v-bind="field"
      v-maska="{ 'mask': mask, 'tokens': tokens }" @maska="emits" @input="emits"
      :placeholder=$props.placeholder :aria-label="ariaLabel || undefined"
      :aria-describedby="describedBy || undefined"
      :aria-required="required ? 'true' : undefined"
      :aria-invalid="invalido ? 'true' : undefined" />
  </Field>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field } from 'vee-validate';
import { mask as maskApply, tokens as builtinTokens } from 'maska'

export default defineComponent({
  name: "MaskedField",
  components: { Field },
  props: {
    name: { type: String, required: true },
    placeholder: { type: String, required: false },
    tokens: { type: Object, default: () => { } },
    read: String,
    mask: String,
    /** Id do <input> interno, para um `<label for>` da tela poder apontar para ele. */
    campoId: { type: String, default: '' },
    /** Nome acessível quando não houver `<label>` visível ligado por for/id. */
    ariaLabel: { type: String, default: '' },
    /** Id do elemento que descreve o campo (mensagem de erro, dica de formato). */
    describedBy: { type: String, default: '' },
    /** Marca o campo como obrigatório para o leitor de tela. */
    required: { type: Boolean, default: false },
    /** Marca o campo como inválido para o leitor de tela. */
    invalido: { type: Boolean, default: false },
  },
  data() {
    return {
      maskedValue: ''
    }
  },
  mounted() {
    if (this.read)
      this.topDownChange(this.read);
  },
  methods: {
    // eslint-disable-next-line
    emits(e: any) {
      this.$emit('writeRaw', this.$refs.input.value);
      this.$emit('write', this.maskedValue);
    },
    topDownChange(newValue: string) {
      this.maskedValue = maskApply(newValue, this.mask, { ...builtinTokens, ...this.tokens });
    }
  },
  watch: {
    read(newValue: string) {
      this.topDownChange(newValue);
    }
  }
});
</script>
